module.exports = __webpack_public_path__ + "static/img/1.9993d8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg/1.jpg
// module id = TKPw
// module chunks = 1